import { IReducerAction } from '../../interfaces/IRedux'
import { 
    PROFILE_LOADING,
    PROFILE_END_LOADING,
    PROFILE_CLEAR,
    PROFILE_GET_DATA
 } from '../types'

const initialState = {
    loading: false,
    data: {},
    notifications: []
}

export default function reducer(state = initialState, action: IReducerAction) {
    const payload = action.payload || {}

    switch (action.type) {
        case PROFILE_LOADING:
            return {
                ...state,
                loading: true
            }

        case PROFILE_END_LOADING:
            return {
                ...state,
                loading: false
            }

        case PROFILE_GET_DATA:
            return {
                ...state,
                loading: false,
                data: payload
            }

        case PROFILE_CLEAR:
            return initialState
        default:
            return state
    }
}